export default {"src":"/_next/static/media/diamond-red.bc7f0f05.svg","height":25,"width":26};